import React, { useEffect, useState } from "react";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Account() {
    const { user, logout } = useAuth();
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/orders");
                setOrders(data);
            } catch {}
        })();
    }, []);

    return (
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 animate-fade-slide">
            <h1 className="font-heading font-black text-4xl md:text-6xl tracking-tighter mb-8">My account</h1>
            <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white border border-brand-line rounded-2xl p-6">
                    <h3 className="font-heading font-bold text-xl mb-4">Profile</h3>
                    <p className="text-sm text-brand-moss">Name</p>
                    <p className="font-bold" data-testid="account-name">{user?.name}</p>
                    <p className="text-sm text-brand-moss mt-3">Email</p>
                    <p className="font-bold" data-testid="account-email">{user?.email}</p>
                    <button onClick={logout} className="mt-6 bg-brand-ink text-white font-bold px-5 py-2.5 rounded-xl text-sm hover:bg-brand-orange transition">
                        Log out
                    </button>
                </div>
                <div className="bg-white border border-brand-line rounded-2xl p-6 md:col-span-2">
                    <h3 className="font-heading font-bold text-xl mb-4">Recent orders</h3>
                    {orders.length === 0 ? (
                        <p className="text-brand-moss text-sm">No orders yet. <Link to="/products" className="text-brand-orange font-bold">Shop now</Link></p>
                    ) : (
                        <div className="space-y-3">
                            {orders.slice(0, 5).map((o) => (
                                <div key={o.id} className="flex justify-between items-center text-sm py-2 border-b border-brand-line last:border-0">
                                    <div>
                                        <p className="font-mono text-xs text-brand-moss">{o.id.slice(0, 8)}...</p>
                                        <p className="font-bold">{o.items?.length || 0} items</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="font-heading font-black">₹{o.totals?.total?.toFixed(0)}</p>
                                        <p className="text-xs text-brand-moss">{o.status}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
